// export DsfSelect from "./select";
// export DsfCascader from "./cascader";
// export DsfRadioBox from "./radioBox";
// export DsfCheckBox from './checkBox';
// export DsfOuaSelect from './ouaSelect';
// export DsfAreaSelect from './areaSelect';
// export DsfDataChoice from './dataChoice';
// export DsfSwitch from './switch';
// export DsfSignature from './signature';
// export DsfTag from './tag';
// export DsfAreaSelectDialog from './areaSelectDialog';
// export DsfEncryptLevel from "./encryptLevel.vue"

export DsfSelect from "./select";
export DsfRadioBox from "./radioBox";
export DsfCheckBox from "./checkBox";

function loaderDataChoice() {
  return import(/*webpackChunkName:"platform_pc_form"*/ "./dataChoice");
}


export const DsfAreaSelect = dsf.defineLazyComponent("DsfAreaSelect", () =>
  require( "./areaSelect")
);

export const DsfCascader = dsf.defineAsyncComponent("DsfCascader", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./cascader")
);

export const DsfDataChoice = dsf.defineAsyncComponent("DsfDataChoice", loaderDataChoice);

export const DsfOuaSelect = dsf.defineAsyncComponent("DsfOuaSelect", () => {
  //tag组件依赖于DsfDataChoice，而DsfDataChoice又是一个异步组件
  return dsf.requestAsyncComponents(DsfDataChoice).then(() => {
    return import(/*webpackChunkName:"platform_pc_form"*/ "./ouaSelect");
  });
});

export const DsfSwitch = dsf.defineAsyncComponent("DsfSwitch", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./switch")
);
export const DsfTag = dsf.defineAsyncComponent("DsfTag", () => {
  //tag组件依赖于DsfDataChoice，而DsfDataChoice又是一个异步组件
  return dsf.requestAsyncComponents(DsfDataChoice).then(() => {
    return import(/*webpackChunkName:"platform_pc_form"*/ "./tag");
  });
});
export const DsfSignature = dsf.defineAsyncComponent("DsfSignature", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./signature.vue")
);
export const DsfAreaSelectDialog = dsf.defineAsyncComponent("DsfAreaSelectDialog", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./areaSelectDialog.vue")
);

export const DsfEncryptLevel = dsf.defineAsyncComponent("DsfEncryptLevel", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./encryptLevel.vue")
);
